define("shared/components/shared/ui/switcher/item", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li aria-current={{@selected}} class="o--dropBody__item u--p__0" data-qa-id={{@option.qaId}} ...attributes>
    <span
      class={{concat-classes
        "o--dropBody__link u--p__l__xs"
        (if @selected "u--flex u--flex__justify--between u--flex__alignItems--center")
      }}
      draggable="false"
      ondragstart="return false;"
    >
      <Shared::Ui::Switcher::Option @onClick={{@onClick}} @option={{@option}} />
      {{#if @selected}}
        {{svg-jar "check" class="o--icon o--icon--light"}}
      {{/if}}
    </span>
  </li>
  */
  {
    "id": "7dPqXW/R",
    "block": "[[[11,\"li\"],[16,\"aria-current\",[30,1]],[24,0,\"o--dropBody__item u--p__0\"],[16,\"data-qa-id\",[30,2,[\"qaId\"]]],[17,3],[12],[1,\"\\n  \"],[10,1],[15,0,[28,[37,0],[\"o--dropBody__link u--p__l__xs\",[52,[30,1],\"u--flex u--flex__justify--between u--flex__alignItems--center\"]],null]],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[12],[1,\"\\n    \"],[8,[39,2],null,[[\"@onClick\",\"@option\"],[[30,4],[30,2]]],null],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@selected\",\"@option\",\"&attrs\",\"@onClick\"],false,[\"concat-classes\",\"if\",\"shared/ui/switcher/option\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/switcher/item.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});